<template>
  <div>logout...</div>
</template>

<script>
import URLQueryString from '@/utils/queryString'
import Auth from "@/apiClient/Auth";
import { isEmpty } from 'lodash'
export default {
  name: "logoutSAML",
  data() {
    return {
      urlQueryString: {},
      auth: null
    }
  },
  methods: {
    async logoutSAML() {
      if (isEmpty(this.urlQueryString.queryPath)) {
        await this.$store.dispatch('clearState')
        await this.$router.push('login')
      }
      let samlRequest = this.urlQueryString.queryPath.SAMLRequest
      let sigAlg = this.urlQueryString.queryPath.SigAlg
      let signature = this.urlQueryString.queryPath.Signature
      try {
        await this.auth.logoutSAML(samlRequest, sigAlg, signature).then(response => {
          this.$store.dispatch('clearState')
          location.replace(response.data.data.url)
        })
      } catch (e) {
        console.error('Error', e)
      }
    }
  },
  mounted() {
    this.logoutSAML()
  },
  created() {
    this.urlQueryString = new URLQueryString(window.location.search)
    this.auth = new Auth()
  }
}
</script>

<style scoped>

</style>
